package ru.it_mozaika.sender.js.application.routes


import ru.it_mozaika.sender.js.application.frames.users.usersFrame
import js.core.jso
import react.Props
import react.createElement
import react.router.RouteObject

val usersRoutes = jso<RouteObject> {
    path = "users"
    element = createElement<Props> {
        usersFrame {}
    }
}